

var article = `
## Pregunta sobre actualizar un fichero
Cuando **pregunta** si deseo **actualizar** un fichero o **conservar** el que tengo, lo mejor será *actualizarlo*.

## Problema de bloqueo de caché
Después de ejecutar el comando **apt upgrade** para actualizar el sistema con los nuevos repos, lo cancelé por error.

Cuando quise ejecutar el comando de vuelta, me apareció un error como este:

> *no se pudo obtener un bloqueo /var/lib...* 
> *Tenga en cuenta que eliminar el archivo que mantiene el proceso puede causar daños...*

La solución fue **reiniciarla** y **ejecutar este comando**:

> **juan@linux:~$** sudo dpkg --configure -a

Ya se puede **volver a intentar**:

> **juan@linux:~$** sudo apt upgrade

## Problema con repositorios (Releases)

Al hacer **apt update** puedo encontrar este error: 

- *'... no tiene fichero de Publicación'*.
- *'... deshabilitado por omisión'*.
- *'... no longer has a Release file'*.

Significa que los repositorios *no se encuentran* o *tienen problemas*.

Asique debo agregar **repositorios que funcionen**.

### Solución para un repositorio

Si, por ejemplo, hay un problema con **un SOLO repositorio**, por ejemplo, tengo un problema con el repositorio:

> deb http://archive.canonical.com/ubuntu **kinetic** partner
> deb-src http://archive.canonical.com/ubuntu **kinetic** partner

Simplemente comento estos repositorios con un almohadilla (**#**) ó directamente los reemplazo por los **repositorios** de la *distribucción anterior*, en este caso, **Jammy**.

Entonces quedaría así:

> **#** deb http://archive.canonical.com/ubuntu **kinetic** partner
> **#** deb-src http://archive.canonical.com/ubuntu **kinetic** partner
>
> deb http://archive.canonical.com/ubuntu **jammy** partner
> deb-src http://archive.canonical.com/ubuntu **jammy** partner

**NOTA:** las **almohadillas** hacen que el sistema *no los tenga en cuenta*.

### Solución para todos los repositorios

Si tengo problemas con **TODOS los repositorios** entonces tengo que buscar una nueva lista de repositorios.

Ver este [enlace para actulizar linux cambiando los repositorios](/blog/actualizar-linux-cambiando-los-repositorios) y **seguir los pasos** que se indican ahí.

## Problema con clave pública (public key)
    
Cuando hay problemas de clave pública, significa que se debe importar una **public-key** válida para los **nuevos repositorios**.

Cuando *aparezca el error*, también aparecerá la **clave pública** que debo agregar al sistema.

Entonces, escribo este comando donde **\\<PUBLIC KEY\\>** es la **clave pública** que nos figura en el *mismo error*:
        
> **juan@linux:~$** sudo apt-key adv --keyserver keyserver.ubuntu.com --recv-keys **\\<PUBLIC KEY>**

Por ejemplo:
            
> **juan@linux:~$** sudo apt-key adv --keyserver keyserver.ubuntu.com --recv-keys **3B4FE6ZCD0B27F32**

Después, **buscar actualizaciones**: 

> **juan@linux:~$** sudo apt update

Y *actualizar*:

> **juan@linux:~$** sudo apt upgrade
`;

export default article;